/**
 * Add Entitys page
 *
 * @author Agbonaye Osaru - osaru@sarutech.com
 */
import { Directive, Input, SimpleChanges, TemplateRef, ViewContainerRef, PipeTransform, Pipe, Component, ViewChild, ElementRef, ViewEncapsulation, Injector, OnChanges, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ToastController, LoadingController, ModalController, AlertController, Platform, ActionSheetController, NavParams } from '@ionic/angular';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { WebcamImage, WebcamInitError } from 'ngx-webcam';
declare var Handsontable: any;
declare var require: any;
import * as moment from 'moment';

/**
 * Services
 */
import { PouchService } from '../services/pouch-service';
import { ImageService } from '../services/image';
import { AddSettingPage } from '../add-setting/add-setting';
import { FileViewerPage } from '../fileviewer/fileviewer';
import { UserTypesPage } from '../user-types/user-types';
import { JsonEditorPage } from '../jsoneditor/jsoneditor';

@Component({
  selector: 'page-add-entity',
  templateUrl: 'add-entity.html',
  styleUrls: ['add-entity.scss'],
  encapsulation: ViewEncapsulation.None,
  //providers: [NavParams]
})
export class AddEntityPage implements OnChanges {
  navParams = {};
  upgrading = false; // prevent upgrading multiple initializations
  @Input() mode: string = 'entity';
  @Input() form_mode: string = 'entity';
  @Input() enable_navparam: boolean = true;
  @Input() showsave: boolean = true;
  @Input() ispage: boolean = true;
  @Input() isobject: boolean = false;
  @Input() isform: boolean = false;
  @Input() form = null;
  @Input() showaction = true;
  objectKeys = Object.keys;
  @Input() entity: any = {
    id: Math.round(new Date().getTime()).toString(),
  };
  @Input() hidefileinput: boolean = false;
  @Input() hidelist = [];
  @Input() hidetype = [];
  @Input() top: any = [];
  @Input() includelist = [];
  @Input() labellist = ['input', 'number', 'password', 'text', 'select', 'checkbox', 'date', 'generate_id', 'datetime-local', 'signature', 'image'];
  @Input() disabledlist = [];
  @Output() onSave = new EventEmitter<any>();
  @Output() selectSpreadsheetRow = new EventEmitter<any>();
  @ViewChild('fileinput') fileinput: ElementRef;
  @ViewChild('table') table;
  datacontainer: any;
  hotdata: any;
  hotsettings;
  inline_texteditor_settings = {};
  forms = [];
  @Input() setting: any = {
    keys: [],
  };
  @Input() title = 'Add';
  objects: any = {};
  public webcam; //will be populated by ack-webcam [(ref)]
  oncam = false;
  showfileinput = false;
  @Input() save = true; //save data or just exit after clicking submit
  showtip = true;
  mindate = 1900;
  maxdate = new Date().getFullYear() + 50;
  frompage = ''; // the page from where the page was called
  isaddform = false;
  input = {
    name: '',
  };
  // latest snapshot
  public webcamImage: WebcamImage = null;
  subscriptions: any = {};
  loading: any;
  images: any = {};

  constructor(
    injector: Injector,
    public loadingCtrl: LoadingController,
    private titleService: Title,
    public http: HttpClient,
    public alertCtrl: AlertController,
    public _DomSanitizer: DomSanitizer,
    public imageService: ImageService,
    public toastController: ToastController,
    public modalCtrl: ModalController,
    public actionSheetCtrl: ActionSheetController,
    public platform: Platform,
    public db: PouchService,
    private router: Router
  ) {
    let navParams2: any = {};
    if (router.url != '/AddEntityPage') {
      navParams2 = injector.get(NavParams);
    }
    if (this.enable_navparam) {
      this.navParams = this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state != undefined ? this.router.getCurrentNavigation().extras.state : navParams2.data;
      // console.log(this.navParams, navParams2.data);
    }
  }

  ionViewWillLeave() {
    let subscriptions = Object.keys(this.subscriptions);
    subscriptions.map((subscription) => {
      this.subscriptions[subscription].unsubscribe();
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    Object.keys(changes).map((key) => {
      if (key == 'entity' && (changes[key].currentValue == undefined || Object.keys(changes[key].currentValue).length === 0)) {
        this.entity = {
          id: Math.round(new Date().getTime()).toString(),
        };
        if (this.enable_navparam) {
          this.generateFields(changes[key].currentValue, this.mode);
        }
        this.ngOnInit();
      } else if (changes[key].currentValue != undefined) {
        if (!this.enable_navparam && key == 'entity') {
        } else {
          this[key] = changes[key].currentValue;
          this.navParams[key] = changes[key].currentValue;
        }
        this.ngOnInit();
      } else {
        // console.log(this[key], key, changes[key].currentValue);
      }
    });
    if (this.hotdata) {
      this.setting.keys.map((key) => {
        if (this.setting[key].type == 'spreadsheet') {
          this.hotsettings.data = this.entity.medications;
          this.hotdata.updateSettings(this.hotsettings);
        }
      });
    }
  }

  async generateFields(entity, key) {
    if (entity == undefined) {
      entity = {};
    }
    this.setting = await this.db.get(key, 'setting');
    await Promise.all(
      this.setting.keys.map(async (key) => {
        //load object sources
        if (entity[key] == undefined || entity[key] == '') {
          //prevent undefined loading old value
          if (this.setting[key].type == 'generate_id' && !entity[key]) {
            this.generateID(key);
          } else if (this.setting[key].val != undefined && this.setting[key].val != '') {
            entity[key] = this.setting[key].val;
          } else if (this.setting[key].type == 'id' || this.setting[key].type == 'rev' || this.setting[key].type == 'spreadsheet' || this.setting[key].type == 'array' || this.setting[key].type == 'connectedobject') {
            //do nothing
          } else if ((this.setting[key].type == 'object' || this.setting[key].type == 'objectfilter') && this.setting[key].showdoc) {
            await this.db.get(key, 'setting').then((objsetting) => {
              this.generateFields({}, objsetting).then((obj) => {
                entity[key] = obj;
              });
            });
          } else if (this.setting[key].type == 'number') {
            entity[key] = 0;
          } else if (this.setting[key].type == 'checkbox') {
            entity[key] = this.setting[key].val || false;
          } else if (this.setting[key].type == 'texteditor') {
            entity[key] = {
              name: this.db.rename(key),
              content: '',
              date: moment().format('YYYY-MM-DDTHH:mm'),
            };
          } else {
            entity[key] = '';
          }
        }
      })
    );
    return entity;
  }

  ngOnInit() {
    if (this.enable_navparam) {
      if (this.navParams != undefined && this.navParams['mode'] != undefined) {
        this.mode = this.navParams['mode'];
        this.titleService.setTitle(`Add ${this.mode} - ${this.db.gsetting.username} - ${this.db.appinfo.title}`);
      }

      if (this.navParams != undefined && this.navParams['mode'] != undefined) {
        this.form_mode = this.navParams['form_mode'];
      }
      if (this.navParams != undefined && this.navParams['save'] != undefined) {
        this.save = this.navParams['save'];
      }
      if (this.navParams != undefined && this.navParams['setting'] != undefined) {
        this.setting = this.navParams['setting'];
      }
      if (this.navParams != undefined && this.navParams['hidelist'] != undefined) {
        // set hidelist that will not be shown in the form
        this.hidelist = this.navParams['hidelist'];
      }
      if (this.navParams != undefined && this.navParams['hidefileinput'] != undefined) {
        this.hidefileinput = this.navParams['hidefileinput'];
      }
      if (this.navParams != undefined && this.navParams['top'] != undefined) {
        this.top = this.navParams['top'];
      }
      if (this.navParams != undefined && this.navParams['disabledlist'] != undefined) {
        this.disabledlist = this.navParams['disabledlist'];
      }
      if (this.navParams != undefined && this.navParams['frompage'] != undefined) {
        this.frompage = this.navParams['frompage'];
      }
      if (this.navParams != undefined && this.navParams['isform'] != undefined) {
        this.isform = this.navParams['isform'];
      }
      if (this.navParams != undefined && this.navParams['isform'] != undefined) {
        this.form = this.navParams['form'];
      }
      if (this.db.gsetting.showtip != undefined && this.db.gsetting.showtip == false) {
        this.showtip = false;
      }
    }

    this.load();
  }

  generateID(key) {
    this.subscriptions[key] = this.db.getAllRx(key.split('_')[0]).subscribe((results) => {
      if (results) {
        let random = Math.floor(Math.random() * (99 - 1 + 1)) + 1;
        const year_month = `${String(new Date().getFullYear()).substr(-2)}${String(new Date().getMonth() + 1).padStart(2, '0')}`;
        this.entity[key] = `${this.setting[key].val}${this.db.user.username.substring(0, 3)}${year_month}${results.length}-${random}`;
      }
    });
  }

  async load() {
    let setting;
    if ((this.isform || this.navParams['isform']) && (this.navParams['form'] != undefined || this.form != undefined)) {
      setting = this.navParams['form'] || this.form;
    } else if (this.mode == 'form') {
      return; // to fix issue with reloading empty form settings
    } else if (this.navParams['setting']) {
      setting = this.navParams['setting'];
    } else {
      setting = await this.db.get(this.mode, 'setting');
      if (setting == undefined && this.db.appinfo.schema_array.includes(this.mode) && !this.upgrading) {
        this.upgrading = true;
        await this.db.get('schema', undefined).then(async (old_schema) => {
          let allsettings = await this.db.fetchLocalSettings().toPromise();
          let all_schema: any = await this.db.fetchLocalSchema('');
          all_schema._rev = old_schema._rev;
          await this.db.update(all_schema, undefined);
          await all_schema.schema.map(async (schema) => {
            if (old_schema.schema.find((_schema) => _schema.singular == schema.singular) == undefined) {
              let new_setting = allsettings.find((setting) => setting.id == schema.singular);
              delete new_setting._id;
              await this.db.update(new_setting, 'setting');
              if (new_setting.id == this.mode) {
                setting = new_setting;
                this.setting = new_setting;
              }
            }
          });
        });
      }
    }
    setting?.keys.sort((x, y) => this.top.indexOf(y) - this.top.indexOf(x) || (this.top.includes(x) ? -1 : 1));
    if (this.enable_navparam || !this.setting?.id) {
      this.setting = setting;
    } else {
      setting = this.setting;
    }
    let keys = setting.keys;
    keys.map((key) => {
      if (key.includes('_name') && !this.includelist.includes(key) && keys.includes(key.replace('_name', ''))) {
        this.hidelist.push(key);
      }
      if (this.mode == 'appointment') {
        // push zoom meeting id and password to hidelist if it is not already there
        if (this.hidelist.indexOf('zoom_meeting_id') == -1 && (this.entity?.type == 'Face to Face' || !this.entity?.type)) {
          this.hidelist.push('zoom_meeting_id');
          this.hidelist.push('zoom_meeting_password');
        }
        if (this.db.gsetting.zoom == undefined) {
          this.hidelist.push('type');
        }
      }
    });

    keys.map((key) => {
      //load object sources
      if (setting[key].type == 'object' || setting[key].type == 'connectedobject' || setting[key].type == 'arraytags' || setting[key].type == 'arrayinput' || setting[key].type == 'objectfields' || setting[key].type == 'objectfilter') {
        this.objects[key] = []; //quickly initialize to prevent constructor error while waiting for subscription results
        if (setting[key].type == 'connectedobject' || setting[key].type == 'arraytags' || setting[key].type == 'arrayinput' || setting[key].type == 'objectfields') {
          //correct the object to include
          key = setting[key].val;
        }
        this.subscriptions[key] = this.db.getAllRx(key).subscribe(async (results) => {
          if (results != null) {
            //remove settng database
            if (key == 'setting') {
              this.objects[key] = results.filter((result) => result.id != this.db.gsetting.id);
            } else {
              if (setting[key]?.type == 'objectfilter') {
                // store all , to help with multiple filters
                if (this.entity == undefined || this.entity[setting[key].val] == undefined) {
                  this.disabledlist.push(key);
                  this.objects[key] = results;
                } else {
                  this.objects[key] = results.filter((result) => result[setting[key].val] == this.entity[setting[key].val]);
                }
                this.objects[`all_${key}`] = results;
              } else {
                this.objects[key] = results;
              }
            }
            if (!this.objects[key + '_name']) {
              this.objects[key + '_name'] = ''; // put under the if condition to avoid changing it if it has already been added by the Add Entity if statement below
              this.objects[key + '_setting'] = await this.db.get(key, 'setting');
            }
          } else {
            this.setting.keys = this.setting.keys.filter((k) => k != key && k != key + '_name' && setting[k].val != key);
          }
        });
      } else if (setting[key].type == 'form') {
        this.subscriptions['form'] = this.db.getAllRx('form').subscribe((results) => {
          if (results != null) {
            this.forms = results;
          }
        });
        if (this.entity[setting[key].val]) {
          this.db.get(this.entity[setting[key].val], setting[key].val).then((entity) => {
            this.objects[key] = entity[key];
          });
        } else {
          this.objects[key] = [];
        }
      } else if (setting[key].type == 'generate_id' && (!this.entity || !this.entity[key])) {
        this.generateID(key);
      }
    });
    if (this.entity != undefined || (this.navParams != undefined && this.navParams['entity'] != undefined) || (!this.isform && this.mode == 'job')) {
      // Edit Entity
      this.title = this.navParams['title'] != undefined ? this.navParams['title'] : 'Edit';
      this.entity = this.navParams['entity'] ||
        this.entity || {
          id: Math.round(new Date().getTime()).toString(),
        };
      //get all images in attachments as urls
      this.getImageAttachments();
      keys.map(async (key) => {
        //load object sources
        //objects
        if ((setting[key].type == 'object' || setting[key].type == 'objectfilter') && this.entity[key] != undefined) {
          this.db.get(this.entity[key], key).then((result) => {
            if (result != undefined) {
              this.objects[key + '_name'] = this.formatter(result);
            }
          });
          this.objects[key + '_setting'] = await this.db.get(key, 'setting');
        }
        if (setting[key].type == 'inline_texteditor') {
          console.log(`${this.entity.id}_${key}`);
          this.inline_texteditor_settings[key] = {
            mode: 'exact',
            elements: `${this.entity.id}_${key}`,
            height: 500,
            menubar: false,
            plugins: ['advlist autolink lists link image charmap print preview anchor', 'searchreplace ice icesearchreplace IceCopyPastePlugin visualblocks code fullscreen', 'insertdatetime media table paste code help wordcount'],
            toolbar1:
              'undo redo | formatselect | bold italic backcolor | \
                    alignleft aligncenter alignright alignjustify | \
                    bullist numlist outdent indent | removeformat | link | openlink | unlink | image | code| ice_toggleshowchanges | help',
            extended_valid_elements: 'p,span[*],delete[*],insert[*]',
            content_css: 'assets/img/tinymce/plugins/ice/demo.css',
            IceCopyPastePlugin: {
              pasteType: 'formattedClean',
              preserve: 'p,a[href],i,em,b,span,ul,ol,li,hr',
            },
            ice: {
              user: { name: this.db.user.fullname, id: this.db.user.id },
              preserveOnPaste: 'p,a[href],i,em,b,span',
              deleteTag: 'delete',
              insertTag: 'insert',
              isTracking: this.navParams['track'],
              plugins: [
                // Add title attributes to changes for hover info
                'IceAddTitlePlugin',
                // Two successively typed dashes get converted into an em-dash
                'IceEmdashPlugin',
                // Track content that is cut and pasted
                'IceCopyPastePlugin',
              ],
            },
            //assets/img/trackchanges.css,
          };
        }
        if (setting[key].type == 'embeddedobject') {
          this.hidelist.push(key);
          if (!this.entity[key]) {
            this.entity[key] = {};
            let embedded_objectsetting = await this.db.get(key, 'setting');
            let embedded_objectkeys = embedded_objectsetting.keys; // get all object keys
            embedded_objectkeys.map((objkey) => {
              if (objkey != 'id' && objkey != 'rev') {
                this.entity[key][objkey] = embedded_objectsetting[objkey].val ? embedded_objectsetting[objkey].val : embedded_objectsetting[objkey].type == 'checkbox' ? false : '';
              }
            });
          }
        }
        //images load from attachments
        if (setting[key].type == 'image' && this.entity.attachments != undefined && this.entity.attachments[key] != undefined) {
          this.db.getAttachment(this.mode, this.entity.id, key).then((file) => {
            this.images[key] = URL.createObjectURL(file);
          });
        }
        //connected object
        if (setting[key].type == 'connectedobject' && this.entity[key] != undefined) {
          this.db.get(this.entity[key], setting[key].val).then((result) => {
            if (result) {
              this.objects[key + '_name'] = this.formatter(result);
            }
          });
          this.objects[key + '_setting'] = await this.db.get(key, 'setting');
        } else if (setting[key].type == 'array' || setting[key].type == 'arraytags' || setting[key].type == 'spreadsheet') {
          if (!this.entity[key]) {
            this.entity[key] = [];
          }
          if (setting[key].type == 'spreadsheet') {
            setTimeout(() => {
              this.spreadsheet(key, setting[key], this.entity[key]);
            }, 500);
          }
        } else if (setting[key].type == 'select' && setting[key].val != undefined) {
          this.entity[key] = this.entity?.[key] || setting[key].val;
        }

        //repair date
        if (setting[key].type == 'datetime-local' && this.mode != 'booking') {
          this.entity[key] = moment(this.entity[key]).format('YYYY-MM-DDTHH:mm');
        }

        if (setting[key].type == 'generate_id' && !this.entity[key]) {
          this.generateID(key);
        }

        //restrict usertype and home page for non admin user
        if ((key == 'usertype' || key == 'homepage' || key == 'pages') && this.db.user.usertype != 'Admin') {
          this.setting.keys = this.setting.keys.filter((dkey) => key != dkey);
        }
      });
    } else if (this.ispage) {
      //Add Entity (not available for component type)
      this.entity = {};
      this.entity.id = Math.round(new Date().getTime()).toString();
      this.entity.rev = '';
      this.entity._attachments = {};
      keys.map(async (key) => {
        if (key != 'id' && key != 'rev') {
          if (this.setting[key].val != undefined) {
            //replace with the settings default value
            this.entity[key] = this.setting[key].val;
          }
          if (this.navParams != undefined && this.navParams[key] != undefined) {
            //if the key value has been passed through navparam for example: customer id or user id
            this.entity[key] = this.navParams[key]; //then initialize customer
            if (setting[key].type == 'object' || setting[key].type == 'objectfilter' || setting[key].type == 'connectedobject' || this.mode == 'sale') {
              // if it is an object, then find the name so you can display it well
              this.db.get(this.entity[key], key).then((result) => {
                if (result != undefined) {
                  if (setting[key].type == 'object' || setting[key].type == 'objectfilter') {
                    //for object show the name of the customer or user...
                    this.objects[key + '_name'] = this.formatter(result);
                  } else if (this.mode == 'sale') {
                    this.entity[key] = this.formatter(result); //replace id with name for sale
                  }
                }
              });
              this.objects[key + '_setting'] = await this.db.get(key, 'setting');
            } else if (setting[key].type == 'date') {
              this.entity[key] = moment(this.entity[key]).format('YYYY-MM-DD');
            } else if (setting[key].type == 'datetime-local') {
              this.entity[key] = moment(this.entity[key]).format('YYYY-MM-DDTHH:mm');
            }
          } else if (key == 'user' && this.navParams['set_user'] != false) {
            //initialize to current user if key is user
            //for object show the name of the customer or user...
            if ((setting[key].type == 'object' || setting[key].type == 'objectfilter') && this.db.user.homepage != 'Calendar') {
              //Do not prefill for receptionist since they typically fill for others
              this.entity[key] = this.db.user.id;
              this.objects[key + '_name'] = this.formatter(this.db.user);
              if (setting.user_name != undefined) {
                this.entity.user_name = this.db.user.fullname;
              }
            } else if (key == 'staff') {
              //the staff who created the appointment
              if (this.mode == 'sale') {
                this.entity[key] = this.formatter(this.db.user); //replace id with name for sale
              } else {
                this.entity[key] = this.db.user.id;
              }
            }
          } else if (setting[key].type == 'select' && setting[key].val != undefined) {
            this.entity[key] = setting[key].val;
          } else if (key == 'date') {
            //Always initialize date to current date to make it easier to add
            this.entity[key] = this.db.localDate(setting[key].type);
          } else if (setting[key].type == 'embeddedobject') {
            this.hidelist.push(key);
            this.entity[key] = {};
            let embedded_objectsetting = await this.db.get(key, 'setting');
            let embedded_objectkeys = embedded_objectsetting.keys; // get all object keys
            embedded_objectkeys.map((objkey) => {
              if (objkey != 'id' && objkey != 'rev') {
                this.entity[key][objkey] = embedded_objectsetting[objkey].val ? embedded_objectsetting[objkey].val : embedded_objectsetting[objkey].type == 'checkbox' ? false : '';
              }
            });
          } else if (setting[key].type == 'texteditor') {
            this.hidelist.push(key);
            this.entity[key] = {
              id: Math.round(new Date().getTime()).toString(),
              rev: '',
              name: '',
              content: '',
              date: moment().format('YYYY-MM-DDTHH:mm'),
              user: this.db.user.fullname,
              usertype: this.db.user.usertype,
            };
          } else if (setting[key].type == 'array' || setting[key].type == 'arraytags' || setting[key].type == 'spreadsheet') {
            this.entity[key] = [];
            if (setting[key].type == 'spreadsheet') {
              setTimeout(() => {
                this.spreadsheet(key, setting[key], this.entity[key]);
              }, 1000);
            }
          }
        }
      });
      /* if (this.navParams != undefined && this.navParams['date'] != undefined) { //for calendar
                  let date = this.navParams['date');
                  var now = new Date();
                  if (date.length === 10) {
                      date = new Date(new Date(date).setHours(now.getHours())).toISOString();
                  }
                  this.entity.date = date;
                  this.entity.end = new Date(new Date(date).setMinutes(new Date(date).getMinutes() + 30)).toISOString(); //Also set end time to date
              } */
      if (this.db.user != undefined) {
        //created by
        this.entity.created_by = this.db.user.fullname;
        this.entity.created_date = new Date().toLocaleString();
      }
    }
  }

  onSelectChange($event) {
    if (this.mode == 'appointment' && $event.target.value == 'Zoom Meeting') {
      this.hidelist = this.hidelist.filter((item) => item !== 'zoom_meeting_id' && item !== 'zoom_meeting_password');
      console.log(this.hidelist);
    } else if (this.mode == 'appointment' && $event.target.value == 'Face to Face') {
      if (this.hidelist.indexOf('zoom_meeting_id') == -1) {
        this.hidelist.push('zoom_meeting_id');
        this.hidelist.push('zoom_meeting_password');
      }
    }
  }

  getImageAttachments() {
    if (this.entity.attachments != undefined) {
      let imagekeys = Object.keys(this.entity.attachments).filter((key) => this.entity.attachments[key].content_type == 'image/png' || this.entity.attachments[key].content_type == 'image/jpeg');
      imagekeys.map((key) => {
        this.db.getAttachment(this.mode, this.entity.id, key).then((file) => {
          this.images[key] = URL.createObjectURL(file);
        });
      });
    }
  }

  copy() {
    this.db.reference = {
      id: this.entity.id,
      mode: this.mode,
      icon: this.setting.icon,
      name: this.entity.name || this.entity.title,
    };
    this.presentToast('Object Reference has been copied to memory, You can paste this in a message or a task', 'toast-success');
  }

  paste() {
    if (this.entity.references == undefined) {
      this.entity.references = [];
    }
    this.entity.references.unshift(this.db.reference);
    this.db.update(this.entity, this.mode).then((entity) => {
      this.db.reference = null; // remove reference from cache
      this.presentToast('Object Reference Copied Successfully', 'toast-success');
    });
  }

  async viewReference(reference) {
    if (reference.mode == 'customer') {
      this.router.navigateByUrl('/CustomerManagementPage', {
        state: { customer_id: reference.id, showsearch: false },
      });
    } else if (reference.mode == 'zoommeeting') {
      this.db.get(reference.id, 'zoommeeting').then((meeting) => {
        this.router.navigateByUrl('/ZoomPage', {
          state: { meeting: meeting, showsearch: false },
        });
      });
    } else if (reference.mode == 'style') {
      this.db.get(reference.id, reference.mode).then(async (style) => {
        let attachment = this.convertToBlob(style._attachments.image);
        let modal = await this.modalCtrl.create({
          component: FileViewerPage,
          componentProps: { attachment: attachment, name: reference.name, ispage: false, hidetools: true },
        });
        modal.onDidDismiss().then((res) => {});
        return await modal.present();
      });
    } else {
      //entity
      this.db.get(reference.id, reference.mode).then((entity) => {
        this.router.navigateByUrl('/AddEntityPage', {
          state: { entity: entity, mode: reference.mode },
        });
      });
    }
  }

  convertToBlob(dataObject) {
    // Split the Data URL to get the Base64 string
    const base64String = dataObject.data.split(',')[1];

    // Decode the Base64 string
    const byteCharacters = atob(base64String);

    // Convert it to a byte array
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    // Create a Blob from the byte array
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: dataObject.type });

    return blob;
  }

  tooltipRenderer(instance, td, row, col, prop, value, cellProperties, settings) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);
    let tooltipText = settings.option_description[prop];
    if (value === null || value === undefined || value === '') {
      td.innerHTML = '<div style="height:100%;width:100%;" title="' + tooltipText + '"></div>';
    } else {
      td.title = tooltipText;
    }
  }

  spreadsheet(item, settings, data) {
    if (!data || data.length == 0) {
      data = [{}];
    }
    let columns = [];
    let colHeaders = [];
    settings.options.map((col) => {
      columns.push({
        data: col,
        renderer: (instance, td, row, col, prop, value, cellProperties) => {
          return this.tooltipRenderer(instance, td, row, col, prop, value, cellProperties, settings);
        },
      });
      colHeaders.push(this.db.rename(col, this.db.language));
    });
    /* if (this.hotdata != undefined) {
      this.hotdata.destroy();
    } */
    this.hotsettings = {
      data: data,
      height: 150,
      search: true,
      columnSorting: true,
      className: 'as-you-type-demo',
      filters: true,
      dataSchema: {},
      columns: columns,
      colHeaders: colHeaders,
      rowHeaders: true,
      rowHeights: 23,
      contextMenu: this.db.demo ? false : ['row_above', 'row_below', 'remove_row', 'copy', 'cut', 'undo', 'redo'],
      manualColumnMove: true,
      manualRowMove: true,
      manualColumnResize: true,
      manualRowResize: true,
      readOnly: this.entity.locked,
      afterSelection: (row, column, row2, column2, preventScrolling, selectionLayerLevel) => {
        this.selectSpreadsheetRow.emit(row);
      },
      afterDeselect: () => {
        // this.selectSpreadsheetRow.emit(null);
      },
      licenseKey: 'non-commercial-and-evaluation',
    };
    this.datacontainer = document.getElementById(item);
    this.hotsettings.afterChange = (changes) => {
      if (changes != null) {
        changes.forEach(([row, prop, oldValue, newValue]) => {
          if (this.hotdata.getCell(row, this.hotdata.propToCol(prop)) != null && this.hotdata.getCell(row, this.hotdata.propToCol(prop)).classList[2] === 'htInvalid' && this.setting[prop].type == 'number') {
            this.presentToast('Field must be a number', 'toast-danger');
          } else {
            if (this.entity[item][row] == undefined) {
              this.entity[item][row] = {};
            }
            this.entity[item][row][prop] = newValue;
          }
        });
      }
    };
    if (this.datacontainer) {
      this.hotdata = new Handsontable(this.datacontainer, this.hotsettings);
      const plugin = this.hotdata.getPlugin('ManualColumnResize');
      plugin.setManualSize(0, 150);
      this.hotdata.render();
    }
  }

  async presentToast(message, type = 'toast-success') {
    const toast = await this.toastController.create({
      message: message,
      duration: 4000,
      cssClass: type,
    });
    toast.present();
  }

  sign($event, item) {
    if ($event.value) {
      this.entity[item] = this.db.user.fullname;
      if (this.setting.keys.includes('validated_date')) {
        this.entity.validated_date = moment().format('YYYY-MM-DDTHH:mm');
      }
    }
  }

  customTrackBy(index: number, obj: any): any {
    return index;
  }

  formformatter(item) {
    return item['@form_name'] + ' ____ ' + item['date'];
  }

  addformformatter(item) {
    return item['@name'];
  }

  arrayinputformatter(item) {
    let value = '';
    if (item.name != undefined) {
      value += item.name;
    }
    if (item.title != undefined) {
      value += item.title;
    }
    if (item.specimen != undefined) {
      value += ' ____ ' + item.specimen;
    }
    if (item.conventional_unit != undefined) {
      value += ' ____ ' + item.conventional_unit;
    }
    if (item.modality != undefined) {
      value += ' ____ ' + item.modality;
    }
    return value;
  }

  pageinputformatter(item) {
    let value = '';
    if (item != undefined) {
      if (item.name != undefined) {
        value += item.name;
      }
    }
    return value;
  }

  formatter(item) {
    let value = '';
    let basic_fields = ['name', 'title', 'fullname', 'date', 'id'];
    let first_key = Object.keys(item).filter((key) => basic_fields.includes(key))[0];
    value += item[first_key];
    return value;
  }

  objectformatter = (key: string) => {
    return (item: any) => {
      if (!item) return '';
      // Special logic for prescription mode
      if (item.date_of_birth !== undefined && this.mode === 'prescription') {
        this.entity.date_of_birth = item.date_of_birth;
      }
      let value = '';
      const basic_fields = ['name', 'title', 'fullname', 'date', 'id'];
      const first_key = Object.keys(item).find((k) => basic_fields.includes(k));
      value += item[first_key];
      if (this.objects[`${key}_setting`]) {
        this.objects[`${key}_setting`].keys?.forEach((k) => {
          if (this.objects[`${key}_setting`][k].search && first_key !== k && item[k] !== undefined) {
            value += ' ____ ' + item[k];
          }
        });
      } else if (this.setting[key].type == 'connectedobject' && this.objects[`${this.setting[key].val}_setting`]) {
        // for connected object
        this.objects[`${this.setting[key].val}_setting`].keys?.forEach((k) => {
          if (this.objects[`${this.setting[key].val}_setting`][k].search && first_key !== k && item[k] !== undefined) {
            value += ' ____ ' + item[k];
          }
        });
      }
      return value;
    };
  };

  async addForm(form, key) {
    let modal = await this.modalCtrl.create({
      component: AddEntityPage,
      componentProps: {
        mode: key,
        isform: true,
        form: form,
        save: false,
        entity: {
          id: Math.round(new Date().getTime()).toString(),
          rev: '',
          '@form': form.id,
          '@form_name': form['@name'],
          date: moment().format('YYYY-MM-DDTHH:mm'),
          customer: this.entity.customer,
          user: this.db.user.id || this.db.user._id,
          user_name: this.db.user.fullname,
        },
      },
    });
    modal.onDidDismiss().then((res) => {
      console.log(res);
      if (res.data != undefined) {
        if (!this.entity[key]) {
          this.entity[key] = [];
        }
        this.entity[key].unshift(res.data);
      }
    });
    return await modal.present();
  }

  manageForms() {
    this.router.navigateByUrl('/FormPage');
  }

  selectForm(form, item) {
    if (this.entity[item] == undefined) {
      this.entity[item] = [];
    }
    this.entity[item].unshift(form);
  }

  async printEntity() {
    // Make sure entity is serializable
    const entity = JSON.parse(JSON.stringify(this.entity));
    this.dismiss(this.entity);
    this.router.navigateByUrl('/PrintEntityPage', { state: { entity: entity, mode: this.mode } });
  }

  selectItem(val, item, inputElement = null) {
    if (val.id != undefined) {
      this.objects[item + '_name'] = this.formatter(val); // use formatter function to return the appropriate name for the selected object
      if (this.setting[item].type == 'arrayinput') {
        if (!Array.isArray(this.entity[item])) {
          this.entity[item] = [];
        }
        this.entity[item].push(val);
      } else if (this.setting[item].type == 'objectfields') {
        this.entity[item] = val.id;
        this.db.get(this.setting[item].val, 'setting').then((setting) => {
          setting.keys.map((key) => {
            if (this.setting.keys.includes(key)) {
              this.entity[key] = val[key];
            }
          });
        });
      } else if (this.setting.keys.some((key) => this.setting[key].val == item && this.setting[key].type == 'form')) {
        this.entity[item] = val.id;
        let key = this.setting.keys.find((key) => this.setting[key].val == item && this.setting[key].type == 'form');
        this.db.get(this.entity[item], item).then((entity) => {
          this.objects[key] = entity[key];
        });
      } else if (this.setting[item].type == 'object' || this.setting[item].type == 'connectedobject' || this.setting[item].type == 'objectfilter') {
        this.entity[item] = val.id;
        this.db.get(this.setting[item].val || item, 'setting').then((setting) => {
          this.entity[`${item}_name`] = val['name'] || val.fullname || val.title; // do for _name as it is ignored in setting keys
          setting.keys.map((key) => {
            // for others
            //if entity name is also a field set it automatically
            if (this.setting.keys.includes(`${item}_${key}`)) {
              this.entity[`${item}_${key}`] = val[key];
            }
          });
        });
      } else {
        this.entity[item] = val.id;
      }
      this.setting.keys.map((key) => {
        if (this.setting[key].type == 'objectfilter' && this.setting[key].val == item) {
          this.disabledlist = this.disabledlist.filter((k) => k !== key);
          this.objects[key] = this.objects[`all_${key}`].filter((result) => result[item] == this.entity[item]);
        }
      });

      //if bed allotment, set the name as the patient name
      if (this.mode == 'booking') {
        this.entity.name = this.formatter(val);
      }

      //if specimen, and patient is selected, limit lab request to show only patient request
      if (this.mode == 'specimen' && item == 'customer') {
        this.objects['laboratoryrequest'] = this.objects['laboratoryrequest'].filter((request) => request.customer == val.id);
      }

      //if user_type is a field
      if (item == 'user' && this.setting.keys.includes('user_type')) {
        this.entity['user_type'] = val.usertype;
      }

      //clear the input field
      if (inputElement) {
        inputElement.value = '';
      }
    } else if (this.setting[item].type == 'page') {
      if (item == 'homepage' && val.route == '/EntitysPage') {
        this.presentToast('You cannot set the homepage to an EntitysPage', 'toast-danger');
      } else {
        this.entity[item] = val.route;
      }
    }
    this.input = {
      name: '',
    };
  }

  async addEntity(item) {
    let modal;
    if (item == 'usertype') {
      modal = await this.modalCtrl.create({ component: UserTypesPage, componentProps: { entity: undefined, mode: this.mode } });
    } else {
      modal = await this.modalCtrl.create({ component: AddEntityPage, componentProps: { mode: item, hidetype: ['object', 'array'] } });
    }
    modal.onDidDismiss().then((res) => {
      console.log('done');
    });
    await modal.present();
  }

  async viewJSON() {
    let modal = await this.modalCtrl.create({
      component: JsonEditorPage,
      componentProps: { entity: this.entity },
    });
    modal.onDidDismiss().then((res) => {
      if (res.data != undefined) {
        this.entity = res.data;
      }
    });
    await modal.present();
  }

  async viewEntity(id, item, type = '') {
    if (type == 'object') {
      //id is actual entity
      let modal = await this.modalCtrl.create({
        component: AddEntityPage,
        componentProps: { entity: id, mode: item, isobject: true },
      });
      modal.onDidDismiss().then((res) => {
        if (res.data != undefined) {
          this.entity[item] = res.data;
        }
      });
      const { data } = await modal.onWillDismiss();
      return await modal.present();
    } else if (type == 'form') {
      //id is actual form
      let form = this.forms.find((form) => form.id == id['@form']);
      let modal = await this.modalCtrl.create({
        component: AddEntityPage,
        componentProps: {
          mode: type,
          isform: true,
          form: form,
          save: false,
          entity: id,
        },
      });
      modal.onDidDismiss().then((res) => {
        if (res.data != undefined) {
          let index = this.entity[item].findIndex((_form) => _form.id == id.id); //find and update form
          this.entity[item][index] = res.data;
          this.db.update(this.entity, this.mode).then((res) => {
            this.presentToast('Form Saved Successfully', 'toast-success');
          });
        }
      });
      return await modal.present();
    } else if (id == undefined || id == '') {
      let modal = await this.modalCtrl.create({
        component: AddEntityPage,
        componentProps: { mode: item },
      });
      modal.onDidDismiss().then((res) => {
        if (res.data != undefined) {
          this.entity[item] = res.data['id'];
          this.db.update(this.entity, this.mode);
        }
      });
      return await modal.present();
    } else {
      this.db.get(id, item).then(async (entity) => {
        let modal = await this.modalCtrl.create({
          component: AddEntityPage,
          componentProps: { entity: entity, mode: item },
        });
        modal.onDidDismiss().then((res) => {
          if (res.data != undefined) {
            this.entity[item] = res.data['id'];
            this.db.update(this.entity, this.mode);
          }
        });
        return await modal.present();
      });
    }
  }

  viewEntities(item) {
    this.router.navigateByUrl('/EntitysPage', {
      state: { mode: item, parent: this.setting.id, val: this.entity.id },
    });
  }

  check() {
    let pass = true;
    this.setting.keys.map((key) => {
      if (key == 'status' && this.entity[key] == 'Completed' && this.entity.date_completed == undefined) {
        //set completed date for entities like radiology, and laboratory requests
        this.entity.date_completed = moment().format('YYYY-MM-DDTHH:mm');
      }
      if (this.setting[key].type == 'object' || this.setting[key].type == 'objectfilter') {
      } else if (this.setting[key].required && (this.entity[key] == undefined || this.entity[key] === '')) {
        pass = false;
      }
    });
    //for updating inventory for product loan page
    if (this.mode == 'productloan') {
      if (this.entity.complete == undefined) {
        this.entity.complete = false;
        this.db.get(this.entity.product, 'product').then((product) => {
          product.quantity = parseFloat(product.quantity) - parseFloat(this.entity.quantity_borrowed);
          this.db.update(product, 'product');
        });
      } else if (this.entity.complete == false && this.entity.status == 'returned') {
        this.entity.complete = true;
        this.db.get(this.entity.product, 'product').then((product) => {
          product.quantity = parseFloat(product.quantity) + parseFloat(this.entity.quantity_returned);
          this.db.update(product, 'product');
        });
      } else if (this.entity.complete == false && (this.entity.quantity_returned != 0 || this.entity.date_returned != undefined)) {
        pass = false;
        this.presentToast('Please change status to returned', 'toast-danger');
      }
    }
    return pass;
  }

  submit() {
    if (this.check()) {
      if (this.save && (this.navParams['isobject'] != true || this.navParams['isform'] != true)) {
        //dont save object
        if (this.title == 'Add' && this.mode == 'category') {
          //nice name for category id
          this.entity.id = this.entity.name.replace(/[^A-Z0-9]/gi, '_').substring(0, 16);
        }
        if (this.mode == 'user') {
          // email user his details if he has an email
          if (this.entity.email != undefined) {
            this.db.sendEmailToUser(
              this.entity.email,
              'User Registration for ' + this.db.appinfo.title,
              `
                <p>Dear ${this.entity.fullname},</p>
                <p>You have been registered as a user of <strong>${this.db.appinfo.title}</strong>.</p>
                <p>Here are your details:</p>
                <ul>
                  <li>Database Name: <strong>${this.db.gsetting.username}</strong></li>
                  <li>User Name: <strong>${this.entity.username}</strong></li>
                  <li>Password: <strong>${this.entity.password}</strong></li>
                </ul>
                <p>Here is the link to login: <a href="https://apps.sarutech.com/${this.db.appinfo.base_product}" target="_blank">https://apps.sarutech.com/${this.db.appinfo.base_product}</a></p>
                <p>Regards,<br>The ${this.db.appinfo.title} Team</p>
              `
            );
          }
        }
        this.db.update(this.entity, this.mode).then((entity) => {
          this.onSave.emit();
          this.dismiss(entity);
        });
      } else {
        this.onSave.emit();
        this.dismiss(this.entity);
      }
    } else {
      this.presentToast('Enter Required Fields', 'toast-danger');
    }
  }

  dismiss(entity) {
    if (this.ispage) {
      this.modalCtrl.dismiss(entity);
    } else if (this.save) {
      this.presentToast('Item was saved Successfully', 'toast-success');
    }
  }

  async picture(item) {
    let actionSheet = await this.actionSheetCtrl.create({
      header: 'Add Product Picture?',
      buttons: [
        {
          text: 'From Camera',
          handler: () => {
            this.camera(item);
          },
        },
        {
          text: 'Select Picture',
          handler: () => {
            if (this.platform.is('cordova')) {
              this.selectImage(item);
            } else {
              this.showfileinput = true;
            }
          },
        },
        {
          text: this.db.rename('Cancel'),
          role: 'cancel',
          handler: () => {},
        },
      ],
    });
    actionSheet.present();
  }

  camera(item) {
    if (this.platform.is('cordova')) {
      this.imageService
        .takePhotograph()
        .then((image) => {
          this.entity[item] = image.toString();
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      if (this.oncam) {
        this.imageService.trigger.next();
      } else {
        this.oncam = true;
      }
    }
  }

  cancelcamera() {
    this.oncam = false;
  }

  filter(item, filter, val) {
    return this.objects[item].filter((object) => object[filter] == val);
  }

  deleteArrayInput(item, parent, child) {
    if (child) {
      this.entity[item].map((_parent) => {
        if (_parent.id == parent.id) _parent.children = _parent.children.filter((value) => value.id != child.id);
      });
    } else {
      this.entity[item] = this.entity[item].filter((value) => value.id != parent.id);
    }
  }

  getAttachments() {
    return Object.keys(this.entity.attachments).filter((key) => this.entity.attachments[key].comment != true);
  }

  download(item) {
    var file = this.entity._attachments[item].data;
    var url = null;
    if (navigator.msSaveBlob) {
      url = navigator.msSaveBlob(file, this.entity[item]);
    } else {
      url = window.URL.createObjectURL(file);
    }
    var tempLink = document.createElement('a');
    tempLink.href = url;
    tempLink.setAttribute('download', this.entity[item]);
    tempLink.click();
    window.URL.revokeObjectURL(url);
  }

  imageListener($event, item): void {
    if (this.entity.attachments == undefined) {
      this.entity.attachments = {};
    }
    var file: File = $event.target.files[0];
    this.entity.attachments[item] = {
      type: file.type,
      data: file,
      name: file.name,
      content_type: file.type,
    };
    this.entity[item] = undefined; //unset this to prevent previous data from loading
    this.images[item] = URL.createObjectURL(file); //now set it to show for the first time.
  }

  fileListener(files: FileList, item, iscomment = false) {
    Array.from(files).forEach((file) => {
      if (file != undefined) {
        if (this.entity.attachments == undefined) {
          this.entity.attachments = {};
        }
        this.entity.attachments[file.name] = {
          type: file.type,
          data: file,
          name: file.name,
          content_type: file.type,
          iscomment: iscomment, //to know whether to filter it and show close to comments
        };
        this.db.update(this.entity, this.mode).then((entity) => {
          this.presentToast('File saved Successfully', 'toast-success');
          //this.getImageAttachments(); commented out as you cannot load this from a component page like task page without gounf through @Input() route
        });
        document.getElementById('commentfileinput')['value'] = null;
      }
    });
  }

  viewFile(item) {
    this.db.getAttachment(this.mode, this.entity.id, item).then(async (attachment) => {
      let modal = await this.modalCtrl.create({
        component: FileViewerPage,
        componentProps: { attachment: attachment, name: item },
      });
      modal.onDidDismiss().then((res) => {});
      return await modal.present();
    });
  }

  selectImage(item) {
    this.imageService
      .selectPhotograph()
      .then((image) => {
        this.entity[item] = image.toString();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  public handleImage(webcamImage: any, item): void {
    if (this.entity.attachments == undefined) {
      this.entity.attachments = {};
    }
    this.db.urltoFile(webcamImage.imageAsDataUrl, item, 'image/png').then((file) => {
      this.entity.attachments[item] = {
        type: file.type,
        data: file,
        name: file.name,
        content_type: file.type,
      };
      this.entity[item] = undefined; //unset this to prevent previous data from loading
      this.images[item] = URL.createObjectURL(file); //now set it to show for the first time.
      this.oncam = false;
    });
  }

  dictionary() {
    this.router.navigateByUrl('/DrugDictionaryPage', {});
  }

  async viewSetting(mode = undefined) {
    let modal = await this.modalCtrl.create({
      component: AddSettingPage,
      componentProps: { mode: mode },
    });
    modal.onDidDismiss().then((res) => {
      this.load();
    });
    return await modal.present();
  }

  async sendSMS() {
    if (this.db.demo) {
      this.presentToast('Cannot send SMS in DEMO!!!', 'toast-danger');
    } else if (!this.db.gsetting.vonage_api_key || !this.db.gsetting.vonage_api_secret) {
      this.presentToast('Please set up your Vonage API Key and Secret in the settings page', 'toast-danger');
      this.router.navigateByUrl('/SystemSettingsPage');
      this.modalCtrl.dismiss();
    } else if (this.entity.customer != undefined || !this.db.demo) {
      this.db.get(this.entity.customer, 'customer').then(async (customer) => {
        if (customer.mobile != undefined && customer.mobile != '') {
          let message = 'Dear ' + customer.name + ', Your Appointment has been scheduled for ' + this.db.rename(this.entity.date, 'date') + ' with ' + this.objects['username'];
          if (this.entity.zoom_meeting_id != undefined && this.entity.zoom_meeting_id != '') {
            message += '. Zoom Meeting ID: ' + this.entity.zoom_meeting_id + '. Zoom Password: ' + this.entity.zoom_meeting_password;
          }
          let phone = customer.mobile;
          if (this.db.gsetting?.sms?.prefix && !phone.startsWith(this.db.gsetting?.sms?.prefix)) {
            //if local
            phone = phone.charAt(0) == '0' ? phone.substring(1) : phone; //add prefix
            phone = `${this.db.gsetting?.sms?.prefix}${phone}`;
          }
          const alert = await this.alertCtrl.create({
            header: 'Send SMS to ' + customer.name,
            inputs: [
              {
                name: 'phone',
                type: 'text',
                value: phone,
              },
              {
                name: 'message',
                type: 'textarea',
                value: message,
              },
            ],
            buttons: [
              {
                text: this.db.rename('Cancel'),
                handler: async () => {},
              },
              {
                text: this.db.rename('Confirm'),
                handler: async (ddata) => {
                  await this.db.sms(ddata.phone, ddata.message);
                },
              },
            ],
          });
          alert.present();
        } else {
          this.presentToast('Please Enter the Patient Phone Number', 'toast-danger');
        }
      });
    } else {
      this.presentToast('Please select a patient', 'toast-danger');
    }
  }

  sendEmail() {
    if (this.entity.customer != undefined) {
      this.db.get(this.entity.customer, 'customer').then((customer) => {
        if (customer.email != undefined && customer.email != '') {
          let subject = 'Appointment with ' + this.objects['username'] + ' for ' + this.db.rename(this.entity.date, 'date');
          let message = 'Dear ' + customer.name + ', Your Appointment has been scheduled for ' + this.db.rename(this.entity.date, 'date') + ' with ' + this.objects['username'];
          if (this.entity.zoom_meeting_id != undefined && this.entity.zoom_meeting_id != '') {
            message += '. \n\nZoom Meeting ID: ' + this.entity.zoom_meeting_id + '. \nZoom Password: ' + this.entity.zoom_meeting_password;
            message += ' \n\n' + this.entity.join_url;
          }
          message += '. \n\nKind Regards, \n' + this.db.gsetting.company;
          this.db.email(customer.email, subject, message);
        } else {
          this.presentToast('Please Enter the Patient Email Address', 'toast-danger');
        }
      });
    } else {
      this.presentToast('Please select a patient', 'toast-danger');
    }
  }

  async createZoomMeeting() {
    if (this.entity.customer != undefined) {
      this.db.get(this.entity.customer, 'customer').then(async (customer) => {
        if (customer.email != undefined && customer.email != '') {
          this.loading = await this.loadingCtrl.create({
            message: `${this.db.rename('Please wait')}...`,
          });
          await this.loading.present();
          this.db.createZoomMeeting(this.entity, customer).then(
            async (meeting) => {
              await this.loading.dismiss();
              this.entity = { ...meeting };
              this.db.update(meeting, 'zoommeeting').then((meeting) => {
                this.presentToast('Meeting Created Successfully', 'toast-success');
              });
            },
            async (err) => {
              await this.loading.dismiss();
              this.presentToast('Error!!! Meeting was not created', 'toast-danger');
              console.log(err);
            }
          );
        } else {
          this.presentToast('Please Enter the Patient Email Address', 'toast-danger');
        }
      });
    } else {
      this.presentToast('Please select a patient', 'toast-danger');
    }
  }

  cancel() {
    //cancel action
    this.modalCtrl.dismiss();
  }

  back() {
    //this.navCtrl.pop();
  }

  help(page) {
    window.open('https://sarutech.com/documentation/' + page);
  }
}
